import React, { useState, memo } from "react";
import { makeStyles } from "@mui/styles";
import filterItems from "~libs/filterItems";
import SearcherList, {
  SearcherListChangeEvent,
} from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import getMarcasTarjetaCredito from "./getMarcasTarjetaCredito";

const useStyles = makeStyles((theme) => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: 10,
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
  },
}));

interface MarcaTarjetaCredito {
  label: string;
  value: string;
}

interface MarcaTarjetaCreditoSelectorProps {
  value?: string | null;
  onChange?: (event: { target: { value: string | null } }) => void; // Change handler
}

const marcasTarjetaCreditoList: MarcaTarjetaCredito[] =
  getMarcasTarjetaCredito();

const MarcaTarjetaCreditoSelector: React.FC<MarcaTarjetaCreditoSelectorProps> =
  memo(({ value, onChange }) => {
    const [filter, setFilter] = useState<string>(""); // Filter is a string

    const handleItem = (item: { label: string; value: string | null }) => {
      setFilter("");
      if (onChange) {
        onChange({ target: { value: item.value || "" } });
      }
    };

    const handleFilterChange = (event: SearcherListChangeEvent) => {
      setFilter(event.target.value);
    };

    const classes = useStyles();

    return (
      <div className={classes.searcher}>
        <SearcherList
          onClear={() => handleItem({ value: null, label: "" })}
          filter={filter}
          onChange={handleFilterChange}
          placeholder={"Buscar marca"}
          borderBottomRounded={undefined}
        />
        <ListView
          onItemSelected={handleItem}
          list={
            filter === ""
              ? marcasTarjetaCreditoList
              : filterItems(marcasTarjetaCreditoList, filter)
          }
        />
      </div>
    );
  });

export default MarcaTarjetaCreditoSelector;
